<template>
  <router-view v-if="profileType == 'Admin' || profileType == 'Agency' || profileType == 'Volunteer'"/>
           <not-found v-else />
</template>

<script>
import { mapGetters } from "vuex";
import NotFound from "../../NotFound.vue";
export default {
  components: {
    NotFound
  },
  computed: {
    ...mapGetters("auth", {
      profile: "getProfile",
      profileType: "getType"
    })
  },
  watch: {
    "profile._id"(newId) {
      if (!this.$route.params.id && newId) {
        this.redirectToProfileEvents(newId);
      }
    },
    "$route.name"(newName) {
      const currentId = this.$route.params.id;
      const profileId = this.profile._id;

      if (newName === "agency-profile" && profileId) {
        this.redirectToProfileEvents(profileId);
      } else if (newName === "agency-profile-details" && !currentId) {
        this.$router.back();
      }
    }
  },
  mounted() {
    const profileId = this.profile._id;
    const currentId = this.$route.params.id;

    if (profileId) {
      if (!currentId || currentId === profileId) {
        this.redirectToProfileEvents(profileId);
      } else if (currentId !== profileId) {
        this.redirectToProfileEvents(currentId);
      }
    }
  },
  methods: {
    redirectToProfileEvents(id) {
      this.$router.replace({
        name: "agency-profile-events",
        params: { id }
      });
    }
  }
};
</script>
